import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { ISpellingWord, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const SPELLING_WORDS_ROOT = ['spellingWords'] as const;

interface SpellingWordsListParams {
    projectId: number;
}

const fetchers = {
    /** The project's dictionary, sorted by word. Outside the versioning
     *  middleware, so it takes no `version`. */
    list: {
        key: (args: SpellingWordsListParams) => [...SPELLING_WORDS_ROOT, 'list', args] as const,
        fetch: async ({ projectId }: SpellingWordsListParams): Promise<ISpellingWord[]> => {
            const response: ResponseType<ISpellingWord[]> = await request(`projects/${projectId}/spelling-words`);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const spellingWordsEntity: EntityDefinition<typeof fetchers> = {
    name: 'spellingWords',
    roots: [SPELLING_WORDS_ROOT],
    fetchers,
};

export const useSpellingWordsList = createEntityQuery(spellingWordsEntity, 'list');

export type { SpellingWordsListParams };
